(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('settings', ['$rootScope', SettingsFn]);

    /* Metronic Settings */
    function SettingsFn($rootScope) {
        var settings = {
            layout: {
                pageSidebarFixed: true, // no scrolling on sidebar
                pageSidebarClosed: false, // sidebar menu state
                pageContentWhite: true, // set page content layout
                pageBodySolid: false, // solid body color state
                pageAutoScrollOnLoad: 0//1000 // auto scroll to top on page load
            },
            assetsPath: '/assets',
            globalPath: '/assets', 
            layoutPath: '/assets/layouts/layout',
            templateInit: templateInit
        };

        $rootScope.settings = settings;


        // set default template values
        function templateInit () {
            // default template
            $rootScope.templatePrefix = 'light2';
            // default page title
            $rootScope.pageTitle = 'my organizer';
        }

        return settings;

    }
})();